export const getSortingPositions = (
    obj: unknown,
    columnPositions: { [key: string]: number },
    key: string
): number => {
    return typeof columnPositions[(obj as { [key: string]: string })[key]] === 'number'
        ? columnPositions[(obj as { [key: string]: string })[key]]
        : 1000;
};
